import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GoogleMapsModule } from "@angular/google-maps";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import {
	ContentReplacementModule,
	ControlLabelModule,
	FeedbackModule,
	IconModule,
	RestModule,
	SearchSelectControlModule,
	SelectControlModule,
	TextAreaControlModule,
} from "@recore-solutions/nstar-lib";
import { AccessKeyDirective } from "./access-key.directive";
import { AddButtonComponent } from "./components/add-button/add-button.component";
import { CountySelectComponent } from "./components/county-select/county-select.component";
import { DropdownSelectComponent } from "./components/dropdown-select/dropdown-select.component";
import { EditHeaderComponent } from "./components/edit-header/edit-header.component";
import { ListingSortSelectComponent } from "./components/listing-sort-select/listing-sort-select.component";
import { ListingStatusSelectComponent } from "./components/listing-status-select/listing-status-select.component";
import { ListingTimeframeSelectComponent } from "./components/listing-timeframe-select/listing-timeframe-select.component";
import { ListingTypeSelectComponent } from "./components/listing-type-select/listing-type-select.component";
import { LoadingProgressBarComponent } from "./components/loading-progress-bar/loading-progress-bar.component";
import { MultiCheckboxComponent } from "./components/multi-checkbox/multi-checkbox.component";
import { PaginationComponent } from "./components/pagination/pagination.component";
import { StandardFooterComponent } from "./components/standard-footer/standard-footer.component";
import { ToolbarComponent } from "./components/toolbar/toolbar.component";
import { ListingMediaUrlPipe } from "./listingMediaUrl.pipe";
import { PidNoDashPipe } from "./pid-no-dash.pipe";
import { ScrollToDirective } from "./scroll-to.directive";
import { TranslatePipe } from "./translate.pipe";
import { LocalizeDatePipe } from "./localize-date.pipe";
import { NumberToWordsPipe } from "./number-to-words.pipe";

@NgModule({
	declarations: [
		TranslatePipe,
		MultiCheckboxComponent,
		DropdownSelectComponent,
		StandardFooterComponent,
		LoadingProgressBarComponent,
		AddButtonComponent,
		EditHeaderComponent,
		PaginationComponent,
		PidNoDashPipe,
		ToolbarComponent,
		AccessKeyDirective,
		ScrollToDirective,
		ListingTypeSelectComponent,
		ListingStatusSelectComponent,
		ListingTimeframeSelectComponent,
		ListingSortSelectComponent,
		CountySelectComponent,
		ListingMediaUrlPipe,
		LocalizeDatePipe,
		NumberToWordsPipe,
	],
	imports: [
		RouterModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule,
		GoogleMapsModule,
		FeedbackModule,
		RestModule,
		IconModule,
		TextAreaControlModule,
		SelectControlModule,
		ControlLabelModule,
		SearchSelectControlModule,
		ContentReplacementModule,
	],
	exports: [
		TranslatePipe,
		MultiCheckboxComponent,
		DropdownSelectComponent,
		StandardFooterComponent,
		LoadingProgressBarComponent,
		AddButtonComponent,
		EditHeaderComponent,
		PaginationComponent,
		PidNoDashPipe,
		ToolbarComponent,
		AccessKeyDirective,
		ScrollToDirective,
		ListingTypeSelectComponent,
		ListingStatusSelectComponent,
		ListingTimeframeSelectComponent,
		ListingSortSelectComponent,
		CountySelectComponent,
		ListingMediaUrlPipe,
		ContentReplacementModule,
		LocalizeDatePipe,
		NumberToWordsPipe,
	],
	providers: [],
})
export class SharedModule {}
